import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import { Button } from '@mui/material';
import PurchaseOrderDialog from '../Procurement/PurchaseOrder/PurchaseOrderModal';
import { useState } from 'react';
import RemarksDialog from './RemarksDialog';






// const paginationModel = { page: 0, pageSize: 10 };

function formatDate(dateString) {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}

export default function PurchaseTable(props) {
  const [SelectedRows, setSelectedRows] = useState([])
  const[SelectedDevices, setSelectedDevises] = useState([])
  const [OpenPo, setOpenPo] = useState(false)
  const[SelectedRequests, setSelectedRequests]=useState(null)
  const [OpenRemarks, setOpenRemarks] = useState(false)




  const handleRemarksOpen=(row)=>{
    setSelectedRequests(row)
    setOpenRemarks(true)
  }



  const handleRemarksClose=()=>{
    setOpenRemarks(false)
  }


  const allcolumns = [
    { field: 'purchase_request_id', headerName: 'Purchase ID', width: 120 },
    {
      field: 'date',
      headerName: 'Date'
      , width: 130,
      renderCell: (params) => (
        formatDate(params.row.created_at)
      )
    },
    {
      field: 'bank_name',
      headerName: 'Bank Name',
      width: 130,
      renderCell: (params) => (
        <div>{params.row.device_details ? params.row.device_details.bank_name : ""}</div>
      )
    },
    {
      field: 'device_name',
      headerName: 'Device Name',
      width: 130,
      renderCell: (params) => (
        <div>{params.row.device_details ? params.row.device_details.name : ""}</div>
      )
    },
    
    {
      field: 'brand_name',
      headerName: 'Brand Name',
      width: 90,
      renderCell: (params) => (
        <div>{params.row.device_details ? params.row.device_details.brand_name : ""}</div>
      )
    },

    {
      field: 'modal_no',
      headerName: 'Modal No',
      width: 120,
      renderCell: (params) => (
        <div>{params.row.device_details ? params.row.device_details.model : ""}</div>
      )
    },
    {
      field: 'quantity',
      headerName: 'Quantity',
      width: 120,
    },
    {
      field: 'deadline',
      headerName: 'Deadline date',
      type: 'number',
      width: 100,
      renderCell: (params) => (
        <div>{params.row.deadline ? params.row.deadline.split("-").reverse().join("/") : ""}</div>
      )
    },
    {
      field: 'approval_status',
      headerName: 'Status',
      width: 120,
      renderCell: (params) => (
        <div>{props.route?params.row.availed_for_purchase_order?"Approved":"Pending":params.row.approval_status}</div>
      )
     
    },
    {
      field: 'created_by',
      headerName: 'Created By',
      width: 200,
      renderCell: (params) => (
        <div>{params.row.created_by?.user_name}</div>
      )
     
    },
    {
      field: 'remarks',
      headerName: 'Remarks',
      width: 120,
      renderCell: (params) => (
        <Button size='small' variant='contained' color='secondary' onClick={() => handleRemarksOpen(params.row)}>
          view
        </Button>
      )
    },
    {
      field: 'action',
      headerName: 'Action',
      width: 120,
      renderCell: (params) => (
        <Button size='small' variant='contained' color='secondary' onClick={() => props.handdleOpenDialog("view", params.row)}>
          view
        </Button>
      )
    }

  ];

  


  const handleItemSelect = (data) => {
    console.log("data for change",data);
    
    setSelectedRows(data)
    const savedData = data.map(item => {
      const foundItem = props.data.data.find(row => row._id === item);
      console.log("Found_items",foundItem);
      
      if (foundItem) {
        return {
          device_id: foundItem['device_details']["_id"],
          quantity: foundItem["quantity"]
        };
      } else {
        return null; // handle cases where item is not found
      }
    });
    
    // Now you have an array named 'savedData' containing objects with _id and quantity (replace with your logic to determine quantity)
    console.log(savedData);
    setSelectedDevises(savedData)
    

  }

  const handleOpenPODialog = () => {
    if (SelectedRows.length > 0) {
      setOpenPo(true)
    }
    else {
      alert("Please select  Purchase request to create PO")
    }
  }

  console.log(SelectedRows);


  const handleClosePo = () => {
    setOpenPo(false)
  }

  const columns = allcolumns.filter(column=>{
    if((column.field==="action")&&props.userrole){
      if(props.userrole.access_type==='maker'){
        return true
      }
      else{
        return true
      }
    }
    else{
      return true
    }
  })
  
  return (
    <Paper sx={{ height: 400, width: '100%' }}>
      <RemarksDialog open={OpenRemarks} handleClose={handleRemarksClose} data={SelectedRequests}/>
      <PurchaseOrderDialog SelectedDevices={SelectedDevices} SelectedRows={SelectedRows} data={props.data && props.data.data ? props.data.data : []} open={OpenPo} handleClose={handleClosePo} />
      {
        sessionStorage.getItem('UserType') === 'pa' && props.filter === 'pending' ?
          <Button size='small' disabled={props.data&&props.data.data&&props.data.data.length>0?false:true} variant='outlined' color='secondary' onClick={() => handleOpenPODialog()}>Create PO</Button>
          :
          null
      }
      {
        props.data && props.data.data && props.data.data.length>0?
        <DataGrid
        rows={props.data && props.data.data ? props.data.data : []}
        columns={columns}
        initialState={{ pagination: {paginationModel:{ page:props.data?props.data.page:0,pageSize:10 }} }}
        pagination
        pageSize={10}
        pageSizeOptions={[10]}
        paginationMode="server"
        getRowId={(row) => row._id}
        rowCount={props.data ? props.data.total_count :10}
        sx={{
              '& .MuiDataGrid-cell': { color: '#0F172A' }, 
              '& .MuiDataGrid-columnHeaders': { backgroundColor: '#F8FAFC', color:"#592375" }, 
              '& .MuiDataGrid-row:hover': { backgroundColor: '#f5f5f5' },
              border:"0px" 
            }}
        isRowSelectable={(params) =>
          !params.row.availed_for_purchase_order &&
          sessionStorage.getItem("UserType") === 'pa' &&
          props.filter === 'pending'
        }
        checkboxSelection
        onRowSelectionModelChange={(row) => handleItemSelect(row)}
        // onPaginationModelChange={(paginationModel) => {
        //   props.handlePageChange(paginationModel.page);
        // }}
        onPaginationModelChange={(pagenation)=>{
          props.handleNext(pagenation.page)
        }
        }
        disableRowSelectionOnClick
      />
      :
      <div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'100%'}}>
        No Data Found
      </div>
      }
      

    </Paper>
  );
}
